// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig?.custom?.products_per_page || 24,
        // Optional
        loadProductFirst: false,
      	optionColorName: 'color',
        activeFilterScrollbar: 'browser',
      	filterTreeMobileStyle: 'style3'
//       	refineByStyle: 'style1'
    },
  	template: {
      	filterRefineItem: '<div class="selected-item {{class.filterOptionLabel}}"><a href="{{itemLink}}"><span class="selected-type"><span class="label {{firstOption}}">{{itemType}}: </span><strong>{{itemLabel}}</strong></span><span class="{{class.clearButton}}"></span></a></div>',
    }
};

var productCounter = 1;

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml':  '<div class="block width--medium-3 spacing--3x js-mobile-fw--blocks">' +
                                '<div class="product--root">' +
  									'<div class="partial--product view--grid index--">' +
      									'<div class="product--image-wrapper">' +
                                            '<div class="product--image">'+
                                                '<a class="image-link" href="{{itemUrl}}">' +
                                                	'{{itemImages}}' +
                                                '</a>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="caption">' +
                                            '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                            	'<h2 class="title font--block-heading">{{itemTitle}}</h2>'+
                                            '</a>'+
                                            '{{itemVendor}}' +
                                            '{{itemPrice}}' +
  											'<div class="font--accent bc-sf-filter-labels">{{itemLabels}}</div>' +
                                        '</div>' +
  									'</div>' +
                                '</div>' +
  							'</div>',
    // Pagination Template
    'previousActiveHtml': '<div class="pagination--left-arrow"><a class="text-colored" href="{{itemUrl}}"><svg class="icon--root icon--arrow-left" viewBox="0 0 16 12"><path d="M3.617 5.016h11.669v1.5h-12.1L7.15 10.48l-1.06 1.06L.53 5.982 6.09.421l1.061 1.06-3.534 3.535z" fill-rule="nonzero"></path></svg></a></div>',
    'previousDisabledHtml': '<div class="pagination--left-arrow"></div>',
    'nextActiveHtml': '<div class="pagination--right-arrow"><a class="text-colored" href="{{itemUrl}}"><svg class="icon--root icon--arrow-right" viewBox="0 0 16 12"><path d="M12.199 6.946H.53v-1.5h12.1L8.664 1.481l1.06-1.06 5.562 5.56-5.561 5.56-1.06-1.06 3.534-3.535z" fill-rule="nonzero"></path></svg></a></div>',
    'nextDisabledHtml': '<div class="pagination--right-arrow"></div>',
    'pageItemHtml': '<li class="pagination--number"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="pagination--number" data-active="true">{{itemTitle}}</li>',
    'pageItemRemainHtml': '<li class="pagination--ellipsis">&hellip;</li>',
    'paginateHtml': '{{previous}}<ul class="pagination--numbers">{{pageItems}}</ul>{{next}}',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildFilterOptionSwatchData = function(fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {
    if (this.checkShowFilterOptionItem(fOItemValue, fOData)) {
        var iLabel = fOItemValue.key, iValue = fOItemValue.key;
        var swatchName = iValue;
        if (fOType == 'collection') {
            iLabel = fOItemValue.label, iValue = fOItemValue.handle;
            swatchName = iLabel;
        }

        var colorOptionsArr = this.getSettingValue('general.colorOptionsArr');
        // Get prefix of swatch from filter option id
        // Ex: By option: pf_opt_color -> color, pf_opt_size -> size
        //     By tag: pf_t_color -> color, pf_t_dimension -> dimension
        var prefixSwatch = fOId.replace('pf_t_', '').replace('pf_opt_', '');
        // Deprecated
        if (colorOptionsArr != '') {
            var isColor = colorOptionsArr.filter(function(item) {
                return fOId.indexOf(item) > -1;
            });
            if (typeof isColor[0] !== 'undefined') {
                prefixSwatch = 'color';
            }
        }
        // Get Swatch name
        swatchName = this.customizeSwatchFileName(swatchName, fOItemValue, fOData);
        // Get item HTML Template & Build data
        var html = this.getTemplate('filterOptionSwatchItem');
        html = this.buildFilterOptionItem(html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData);
        // console.log(prefixSwatch)
        var filePath;
        if(prefixSwatch == "color"){
            // Add Image
            filePath = getFilePath(swatchName, this.swatchExtension, this.getSettingValue('general.swatchImageVersion'));
        }else{
			filePath = getFilePath(prefixSwatch + '-' + swatchName, this.swatchExtension, this.getSettingValue('general.swatchImageVersion'));
        }
      	html = html.replace(/{{itemImageValue}}/g, filePath);
        // Add border
        var border = fOData.hasOwnProperty('borderSwatch') && fOData.borderSwatch != '' ? fOData.borderSwatch : 'none';
        html = html.replace(/{{itemBorder}}/g, border);
        return html;
    }
    return '';
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    //var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  	var itemHtml = this.buildVariantsItem(data, index);

    // Add Column Class and Addition Clearfix
    var itemColumnClass = '';
    var itemClearfix = '';
    switch(bcSfFilterConfig.custom.products_per_row){
      case 3:
        itemColumnClass = 'columns large-4';
        itemClearfix = (productCounter % 3 == 1) ? '<div class="clearfix"></div>' : '';
        break;
      case 4:
        itemColumnClass = 'columns large-3';
        itemClearfix = (productCounter % 4 == 1) ? '<div class="clearfix"></div>' : '';
        break;
      case 6:
        itemColumnClass = 'columns large-2';
        itemClearfix = (productCounter % 6 == 1) ? '<div class="clearfix"></div>' : '';
        break;
    }
    itemHtml = itemHtml.replace(/{{itemAdditionClearfix}}/g, itemClearfix);

    // Add hoverClass
    var itemHoverClass = (bcSfFilterConfig.custom.hover_image_enable && images.length > 1) ? 'has-hover' : '';
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);

    var itemLabelsHtml = '';
    if (onSale) {
      itemLabelsHtml += '<span class="bc-sf-filter-label">Sale</span>';
    }
    if (data.tags) {
      itemLabelsHtml += '<span class="bc-sf-filter-labels font--accent">'
      if (data.tags.indexOf('label1-New') > -1) {
        itemLabelsHtml += '<span class="bc-sf-filter-label">New</span>';
      }
      if (data.tags.indexOf('label2-Pre-order') > -1) {
        itemLabelsHtml += '<span class="bc-sf-filter-label">Pre-order</span>';
      }
      if (data.tags.indexOf('label3-Online Exclusive') > -1) {
        itemLabelsHtml += '<span class="bc-sf-filter-label">Online Exclusive</span>';
      }
      if (data.tags.indexOf('label4-Limited Edition') > -1) {
        itemLabelsHtml += '<span class="bc-sf-filter-label">Limited Edition</span>';
      }
      itemLabelsHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
    itemHtml = itemHtml.replace(/{{itemColumnClass}}/g, itemColumnClass);

    // Add item Image
    var itemImageHtml = '';
  	var product_aspect_ratio = (images.length > 0) ? images[0]['width'] / images[0]['height'] : 1;
    var padding_top = (1/product_aspect_ratio) * 100;
    itemImageHtml += '<div class="image--root" data-aspectratio="' + product_aspect_ratio + '" data-item="image" style="width: 100%;">';
    itemImageHtml += '<div class="image--container" style="padding-top:' + padding_top + '%;" >';
    itemImageHtml += '<img class="lazyload" data-src="' + this.getFeaturedImage(images, '{width}x') + '" data-sizes="auto" data-widths="[295,394,590,700,800,1000,1200,1200]" data-aspectratio="' + product_aspect_ratio + '" alt="{{itemTitle}}" >';
    itemImageHtml += '<noscript><img src="' + this.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" /></noscript>';
    itemImageHtml += '</div>';
    itemImageHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImageHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.vendor_enable) {
        itemVendorHtml += '<p class="vendor"><a href="' + this.buildProductItemVendorUrl(data.vendor) + '">' + data.vendor + '</a>'
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    itemPriceHtml += '<p class="price font--accent">';
  	if (soldOut) {
      	itemPriceHtml += '<span class="sold-out font--accent">' + bcSfFilterConfig.label.sold_out + '</span>';
    } else {
      	if (onSale){
            itemPriceHtml += '<span class="compare-price money font--light-accent">' + this.formatMoney(data.compare_at_price_min) + '</span>' +
                             '<span class="actual-price money font--accent">' + this.formatMoney(data.price_min) + '</span>';
        } else {
            if (priceVaries) {
                itemPriceHtml += bcSfFilterConfig.label.from;
            }
            itemPriceHtml += '<span class="actual-price money font--accent">' + this.formatMoney(data.price_min) + '</span>';
        }
    }

    itemPriceHtml += '</p>';
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Hover Image
//     itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, buildItemImage(data, 'hover'));

    productCounter++;

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

BCSfFilter.prototype.buildVariantsItem = function(data, index) {
	var html = '';

	//Update your code here
	var options = data.options_with_values.find(function(e) { return e.name.toLowerCase() == bcSfFilterSettings.general.optionColorName});

    if (this.queryParams.hasOwnProperty('pf_opt_color')) {
      var colors = this.queryParams.pf_opt_color;
      for (var j = 0; j < colors.length; j++) {
        var color = colors[j];
        var variant = data.variants.find(function(e) { return e.option_color == color});
        if (typeof variant != 'undefined') {
          // Get Template
          var itemHtml = '';

          /* Start customized code */
          //itemHtml = itemHtml.replace(/{{itemImages}}/g, this.optimizeImage(variant.image));

          itemHtml += buildItemVariant(data, variant, bcSfFilterTemplate.productGridItemHtml);
          /* End cusotmized code */

          html += itemHtml;
        }

      }
    } else {
      if (typeof options != 'undefined') {
        var bareOption = options.values;
        var colors = [];
        for (var j = 0; j < data.variants.length; j++) {
          // console.log(data.variants[j])
          // var color = data.variants[j].initial_color;
          var color = data.variants[j].option_color;
          if (typeof color != 'undefined' && colors.indexOf(color) < 0) {
            colors.push(color);
          }
        }
        // console.log(options);
        for (var i = 0; i < colors.length; i++) {
          var value = colors[i];
        // console.log(value)

          // var variant = data.variants.find(function(e) { return e.initial_color == value});
          var variant = data.variants.find(function(e) { return e.option_color == value});
          // Get Template
          var itemHtml = '';

          /* Start customized code */
          //itemHtml = itemHtml.replace(/{{itemImages}}/g, this.optimizeImage(variant.image));
		  itemHtml += buildItemVariant(data, variant, bcSfFilterTemplate.productGridItemHtml);


          /* End cusotmized code */

          html += itemHtml;
        }
      } else {
        html += bcSfFilterTemplate.productGridItemHtml;
      }
    }


	return html;
}

function buildItemVariant(data, variant, itemHtml) {
  var checkSoldOut = isSoldOut(data, variant);
  var variantImage = data.images.find(function(e){return e.src == variant.image;});
  var itemImageHtml = '';
  var product_aspect_ratio = (typeof variantImage != 'undefined') ? variantImage.width/variantImage.height : 1;
  var padding_top = (1/product_aspect_ratio) * 100;
  var imageSrc =  (typeof variantImage != 'undefined') ? variantImage.src : bcSfFilterConfig.general.no_image_url;
  itemImageHtml += '<div class="image--root" data-aspectratio="' + product_aspect_ratio + '" data-item="image" style="width: 100%;">';
  itemImageHtml += '<div class="image--container" style="padding-top:' + padding_top + '%;" >';
  itemImageHtml += '<img class="lazyload" data-src="' + bcsffilter.optimizeImage(imageSrc, '{width}x') + '" data-sizes="auto" data-widths="[295,394,590,700,800,1000,1200,1200]" data-aspectratio="' + product_aspect_ratio + '" alt="{{itemTitle}}" >';
  itemImageHtml += '<noscript><img src="' + bcsffilter.optimizeImage(imageSrc, '1024x1024') + '" alt="{{itemTitle}}" /></noscript>';
  itemImageHtml += '</div>';
  itemImageHtml += '</div>';
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImageHtml);

  // edited by jumpstart DS
  // var $jsTitle = data.title + ' - ' + variant.initial_color;
  var $jsTitle = data.title + ' - ' + variant.option_color;
  if ($(window).width() <= 480 && $jsTitle.length > 30) {
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, $jsTitle.substring(0,30) + '...');
  }else{
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, $jsTitle);
  }
  //
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, bcsffilter.buildProductItemUrl(data) + '?variant=' + variant.id);
  var itemPriceHtml = '';
  itemPriceHtml += '<p class="price font--accent">';
  if (checkSoldOut) {
    itemPriceHtml += '<span class="sold-out font--accent">' + bcSfFilterConfig.label.sold_out + '</span>';
  } else {
    if (variant.compare_at_price > variant.price){
      itemPriceHtml += '<span class="compare-price money font--light-accent">' + bcsffilter.formatMoney(variant.compare_at_price) + '</span>' +
        '<span class="actual-price money font--accent">' + bcsffilter.formatMoney(variant.price) + '</span>';
    } else {
      itemPriceHtml += '<span class="actual-price money font--accent">' + bcsffilter.formatMoney(variant.price) + '</span>';
    }
  }
  itemPriceHtml += '</p>';
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  var itemLabelsHtml = '';
  if (variant.compare_at_price > variant.price && variant.available) {
    itemLabelsHtml += '<span class="bc-sf-filter-label">Sale</span>';
  }
  if (data.tags) {
    if (data.tags.indexOf('label1-New') > -1) {
      itemLabelsHtml += '<span class="bc-sf-filter-label">New</span>';
    }
    if (data.tags.indexOf('label2-Pre-order') > -1) {
      itemLabelsHtml += '<span class="bc-sf-filter-label">Pre-order</span>';
    }
    if (data.tags.indexOf('label3-Online Exclusive') > -1) {
      itemLabelsHtml += '<span class="bc-sf-filter-label">Online Exclusive</span>';
    }
    if (data.tags.indexOf('label4-Limited Edition') > -1) {
      itemLabelsHtml += '<span class="bc-sf-filter-label">Limited Edition</span>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  return itemHtml;
}

function isAvailable(data, color){
  var variants = data.available;
  console.log(data);
  if(variants){
  	return false;
  }else{
  	return true;
  }
}
function isSoldOut(data, color){
  var variants = data.variants;
  var mycolor = color.option_color;
  var quantity = 0;
  for(var i = 0; i < variants.length; i++){
    if(variants[i].option_color == mycolor){
    	quantity = quantity + variants[i].inventory_quantity;
    }
  }
  if(quantity > 0){
  	return false;
  }else{
  	return true;
  }
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        paginationHtml = jQ.parseHTML(paginationHtml);
        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            html = jQ.parseHTML(html);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build additional attributes of product items
BCSfFilter.prototype.buildExtrasProductList = function(data) {
//   jQ(".product--image-wrapper").each(function() {
//     jQ(this).on('mouseover mouseout', function() {
//       var item = jQ(this).children('.product--hover-image');

//       if (item.length > 0) {
//         if (event.type == 'mouseover') {
//           jQ(item).attr('style', 'opacity: 1');
//         } else {
//           jQ(item).attr('style', 'opacity: 0');
//         }
//       }
//     });
//   });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {

  var product_grid = jQ('#bc-sf-filter-products');
  var items = product_grid.find('.block');
  theme.utils.matchImageHeights(product_grid, items, '.product--image-wrapper');

  var stickyElemet = '#bc-sf-filter-tree';
  var startElement = '#bc-sf-filter-tree';
  var endElement = '.footer--root';
  if (!this.isMobile()) {
    jQ(stickyElemet).stickTo(startElement, endElement);
  } else {
    jQ('#bc-sf-filter-tree-mobile').stickTo('#bc-sf-filter-tree-mobile', endElement);
  }
};

jQ.fn.stickTo = function(startElement, endElement) {
    var _this = this;
    var startPos = jQ(startElement).offset().top;
    var endPos = jQ(endElement).offset().top;
    var width = jQ(this).width();
  	var widthElement = (startElement == '#bc-sf-filter-tree') ? '20%' : '100%';
    var setPosition = function() {
        if (jQ(window).scrollTop() < startPos) { // Initial Position
            _this.removeClass('bc-sf-filter-stick');
            _this.css({
                position: 'initial',
                width: widthElement
            });
        } else if (jQ(window).scrollTop() > (endPos - _this.outerHeight() - 100)) { // End Position
            _this.removeClass('bc-sf-filter-stick');
            _this.css({
                position: 'absolute',
                top: '',
                bottom: '0px',
                width: width
            });
        } else { // Fixed Position
            _this.addClass('bc-sf-filter-stick');
            _this.css({
                position: 'fixed',
                top: '0px',
                width: width
            });
        }
    };
    jQ(window).resize(function() {
        endPos = jQ(endElement).offset().top;
        setPosition();
    });
    jQ(window).scroll(setPosition);
    setPosition();
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

BCSfFilter.prototype.buildFilterSelectionData = function(data) {
    function buildItem(template, title, label, clearLink) {
        template = template.replace(/{{itemType}}/g, title);
        template = template.replace(/{{itemLabel}}/g, label);
        template = template.replace(/{{itemLink}}/g, clearLink);
        return template;
    }
    var self = this;
    var selectionContent = '';
    var itemHtml = this.getSettingValue('general.refineByStyle') == 'style2' ? this.getTemplate('filterRefineItem2') : this.getTemplate('filterRefineItem');
    var options = data.filter.options;

    // Get all URL params: return all param keys start with "pf_"
    var paramKeys = Object.keys(self.queryParams);
    paramKeys = paramKeys.filter(function(key) {
        return key.indexOf('pf_') == 0
    });
      // Felix Jul 2025 - Temp hide new Boost layout if there is filter 
    if (Object.keys(paramKeys).length >= 1) {
      jQ('.boost-sd__filter-product-list').hide();
    } else {
      jQ('.boost-sd__filter-product-list').show();
    }
    jQ.each(paramKeys, function(i, key) {
      	// console.log(key);
        var selectedOption = options.filter(function(e) { return e.filterOptionId == key })[0];
        if (typeof selectedOption !== 'undefined' && self.queryParams.hasOwnProperty(key) && self.queryParams[key] && self.queryParams[key].length) {
            var values = self.queryParams[key],
                fOId = selectedOption.filterOptionId,
                fType = selectedOption.filterType,
                fODisplayType = selectedOption.displayType,
                prefix = selectedOption.prefix,
                title = selectedOption.label;
            prefix = (typeof prefix !== 'undefined' && prefix !== null && prefix !== false) ? prefix.replace(/\\/g, '') : '';
            // Make sure values is an Array
            if (!Array.isArray(values)) values = [values];
            // Fix email campaign issue
            // values = values.map(function(value) {
            //     return value.toString().replace(/\+/g, '%20');
            // });
            if (fODisplayType == 'range') {
                /* RANGE SLIDER
                *  - Is advanced range slider: Get first value and last value for min-max
                *  - Is general range slider:  Split value by ":" to get min-max
                **/
                var label = '';
                if (fType.indexOf('price') == -1 && fType !== 'weight' && fType.indexOf('range_slider') == -1) {
                    // Return an Array of values
                    var rangeValues = []
                    if (selectedOption && selectedOption.hasOwnProperty('values')) {
                        rangeValues = selectedOption['values'].map(function(value) {
                            return value.key;
                        });
                    }
                    var currentLabels = rangeValues.length ? self.getAdvancedRangeSelectedValues(values, rangeValues) : [values[0], values[values.length - 1]];
                    label = currentLabels[0].toString().replace(prefix, '');
                    if (values.length > 1) {
                        label += ' - ' + currentLabels[1].toString().replace(prefix, '');
                    }
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, values);
                } else {
                    var value = values[0], elements = value.split(':');
                    if (fType == 'price') {
                        var minPrice = self.formatMoney(elements[0] * 100),
                            maxPrice = self.formatMoney(elements[1] * 100);
                        if (self.getSettingValue('general.removePriceDecimal')) {
                            minPrice = self.removeDecimal(minPrice), maxPrice = self.removeDecimal(maxPrice);
                        }
                        label = minPrice + ' - ' + maxPrice;
                    } else {
                        label = elements[0] + ' - ' + elements[1];
                    }
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, value);
                }
                selectionContent += buildItem(itemHtml, title, label, clearLink);
            } else {
                for (var i = 0; i < values.length; i++) {
                    var value = values[i], label = value;
                    // Customize label
                    label = self.customizeFilterOptionLabel(label, prefix, fType);
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, value);
                    // Remove the prefix in label
                    if (typeof prefix !== 'undefined' && prefix !== null && prefix !== false) {
                        prefix = prefix.replace(/\\/g, '');
                        value = value.replace(prefix, '').trim();
                    }
                    switch (fType) {
                        case 'price': label = self.getPriceLabel(value); break;
                        case 'percent_sale': label = self.getPercentSaleLabel(value); break;
                        case 'stock': label = (value === 'true') ? selectedOption.values[0].label : selectedOption.values[1].label; break;
                        case 'review_ratings':
                            var showExactRating = selectedOption.hasOwnProperty('showExactRating')? selectedOption.showExactRating: false;
                            label = self.getReviewRatingsLabel(value, showExactRating);
                            break;
                    }
                    selectionContent += buildItem(itemHtml, title, label, clearLink);
                }
            }
        }
    });

    var urlParam = window.location.search;
    if (urlParam !== '') {
        urlParam = urlParam.replace('?', '');
        var paramsArr = urlParam.split('&');
        if (paramsArr.indexOf('_=pf') !== -1) {
            paramsArr.splice(paramsArr.indexOf('_=pf'), 1);
        }
        if (jQ('#bc-sf-filter-params').length == 0) {
            jQ('body').append('<input type="hidden" id="bc-sf-filter-params" value="' + paramsArr.join('|') + '" />');
        } else {
            jQ('#bc-sf-filter-params').attr('value', paramsArr.join('|'));
        }
    }
    return selectionContent;
};

BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    var filterSelector = this.getSelector('filterTree');
    var mobileBtnSelector = this.getSelector('filterTreeMobileButton');
    jQ(mobileBtnSelector).unbind('click');
    jQ(mobileBtnSelector).on('click', function() {
        var style = _this.mobileStyle;
        // Full Width style
        if (style == 'style2' || style == 'style3') {
            jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
          	jQ('body').toggleClass('bc-sf-filter-tree-mobile-open');
            // Build mobile content
            _this.buildFilterTreeMobile();
            // Remove scrollbar
            _this.removeScrollbar(jQ('.' + _this.class.filterBlockContent));
        }
        // Default style
        else {
            // Change button text when clicking
            if (_this.getSettingValue('general.changeMobileButtonLabel')) {
                var openClass = _this.class.mobileButtonOpen;
                jQ(this).toggleClass(openClass);
                var label = jQ(this).hasClass(openClass) ? _this.getSettingValue('label.refineMobileCollapse') : _this.getSettingValue('label.refineMobile');
                jQ(this).text(label);
            }
            jQ(filterSelector).slideToggle(function () {
                jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
              	jQ('body').toggleClass('bc-sf-filter-tree-mobile-open');
                _this.buildFilterOptionBoxStyle(jQ(this));                
                // Re-initialize jscrollpane
                _this.buildFilterScrollbar();
            });
        }
    });
};


function closeFilterMobile() {
    jQ('#bc-sf-filter-tree').removeClass('bc-sf-filter-tree-mobile-open');
  	jQ('body').removeClass('bc-sf-filter-tree-mobile-open');
}

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
